import ActivityList from '../../../components/ActivityList';
import PaperSection from '../../../components/PaperSection';

export default function ActivitiesList() {
  return (
    <PaperSection title="Activities">
      <ActivityList endpoint="/admin/activities" showUsers={true} showOrganisations={true} />
    </PaperSection>
  );
}
